module.exports = "https://static.im-cdn.com/mjc/storefront/Esteem/static/media/EmptyStar.b3054035.svg";